import { createFileRoute } from "@tanstack/react-router";
import TrustHub from "@/pages/incredere/TrustHub";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/incredere/")({
  head: () => routeHead("/incredere/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <TrustHub />
  );
}
